import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultBodyComponent } from './default-layout/default-body/default-body.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { authsGuard } from './services/auths.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path:'login',
    component:LoginPageComponent,
  },
  {
    path:'',
    component:DefaultBodyComponent,
    data: {
      title: 'Dashboard'
    },
    children: [
      {
        path:'',
        loadChildren:()=>import('./pages/pages.module').then((m)=>m.PagesModule)
      }
    ],
  canActivate:[authsGuard]
  },
  // {
  //   path:'profile',
  //   component:ProfilePageComponent,
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
